import { find } from '../utils/dom'

export default function () {
	const page = find("[js-page='foundations-class']")
	if (!page) return

	const menu = find("[js-page='menu']")
	if (!menu) return

	const lightSections = page.querySelectorAll('#hero, #what')

	const updateMenu = () => {
		const menuBottom = menu.getBoundingClientRect().bottom

		const overLight = Array.from(lightSections).some((section) => {
			const rect = section.getBoundingClientRect()
			return rect.top < menuBottom && rect.bottom > 0
		})

		menu.classList.toggle('menu-foundations-solid', overLight)
	}

	window.addEventListener('scroll', updateMenu, { passive: true })
	window.addEventListener('resize', updateMenu, { passive: true })
	updateMenu()
}
